import { render, staticRenderFns } from "./slide-items.vue?vue&type=template&id=64515692&scoped=true&"
import script from "./slide-items.vue?vue&type=script&lang=js&"
export * from "./slide-items.vue?vue&type=script&lang=js&"
import style0 from "./slide-items.vue?vue&type=style&index=0&id=64515692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64515692",
  null
  
)

export default component.exports